import { useUser } from '../context/UserContext';

const SIZE_CLASSES = {
  banner:  'w-full h-24',
  sidebar: 'w-full h-64',
  inline:  'w-full h-20',
};

export default function AdSpace({ size = 'banner', className = '' }) {
  const { features } = useUser();

  if (features.is_ad_free) return null;

  if (process.env.NODE_ENV === 'development') {
    return (
      <div
        className={`flex items-center justify-center border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-clay bg-gray-50 dark:bg-gray-800/50 text-gray-400 dark:text-gray-500 text-sm font-medium ${SIZE_CLASSES[size] ?? SIZE_CLASSES.banner} ${className}`}
      >
        Ad Space ({size})
      </div>
    );
  }

  return (
    <div className={`${SIZE_CLASSES[size] ?? SIZE_CLASSES.banner} ${className}`}>
      <ins className="adsbygoogle" style={{ display: 'block' }} />
    </div>
  );
}
